/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_dimension.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the topological dimension of the supplied geometry.
 * Points and multi-points return `0`, lines and multi-lines return `1`, polygons and multi-polygons return `2`, and geometry collections return the maximum dimension of their components.
 *
 * @example
 * ROW wkt = [
 *     "POINT(1.0 2.0)",
 *     "LINESTRING (30 10, 10 30, 40 40)",
 *     "POLYGON ((30 10, 40 40, 20 40, 10 20, 30 10))"]
 * | MV_EXPAND wkt
 * | EVAL geometry = TO_GEOSHAPE(wkt),
 *        type = ST_GEOMETRYTYPE(geometry),
 *        topological_dimension = ST_DIMENSION(geometry)
 * | KEEP type, topological_dimension
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_dimension',
  signatures: [
    {
      params: [
        {
          name: 'geometry',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
